var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.info)?_c('b-container',{staticClass:"p-3 mb-0"},[_c('b-row',[(_vm.info.pics)?_c('b-col',{staticClass:"text-center mt-0 mb-5"},[_c('img',{staticClass:"image_logo",attrs:{"src":_vm.img_path+_vm.image_logo}})]):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }